import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Users } from 'react-feather';
import InfoTooltip from 'components/shared/InfoTooltip';
import ListItem from 'components/shared/ContentTagging/Tag';
import useFetch from 'components/shared/hooks/useFetch';
import { routes, TYPES } from 'constants/config';
import { Icon } from 'ui';
import request from 'utils/request_ajax';
import PeopleSelector from './fields/PeopleSelector';
import Section, { SectionHeader } from './Section';

const isGroup = ({ type }) => type === TYPES.GROUP;

// Sort alphabetically with groups listed first
const groupAndSort = (first, second) =>
  isGroup(second) - isGroup(first) || first.name.localeCompare(second.name);

const Distributors = ({ pathId }) => {
  const [editing, setEditing] = useState(false);
  const [distributors, setDistributors] = useState([]);

  useFetch(routes.PATH_DISTRIBUTORS(pathId), setDistributors);
  const toggleEditing = () => setEditing(!editing);

  const addDistributor = person => {
    request
      .postJSON(routes.PATH_DISTRIBUTORS(pathId), {
        distributor_id: person.id,
        distributor_ums_uuid: person.uuid,
        distributor_type: person.type,
      })
      .then(() => {
        setDistributors([...distributors, person]);
      })
      .catch(e => {
        console.error(e);
      });
  };

  const removeDistributor = person => {
    const personId =
      typeof person.uuid !== 'undefined' ? person.uuid : person.id;
    request
      .delete(routes.PATH_REMOVE_DISTRIBUTORS(pathId, person.type, personId))
      .then(() => {
        setDistributors(
          distributors.filter(
            distributor =>
              distributor.unique_identifier !== person.unique_identifier,
          ),
        );
      })
      .catch(e => {
        console.error(e);
      });
  };
  return (
    <Section>
      <SectionHeader className="d-f jc-sb">
        <span className="w-75p">
          <span className="mr-4">{t('paths.distributors.title')}</span>
          <InfoTooltip tooltip={t('paths.distributors.tooltip')} />
        </span>
        {!editing && (
          <button
            type="button"
            className="u-linkBtn fz-base fw-n"
            onClick={toggleEditing}
          >
            <Icon name="edit" className="mr-4" />
            {t('paths.distributors.edit_button')}
          </button>
        )}
      </SectionHeader>
      <PeopleSelector
        editing={editing}
        toggleEditing={toggleEditing}
        people={distributors.sort(groupAndSort)}
        route={routes.PATH_POTENTIAL_DISTRIBUTORS(pathId)}
        onSelect={addDistributor}
        renderPerson={person => (
          <ListItem
            key={person.unique_identifier}
            editing={editing}
            options={[
              {
                label: t('paths.distributors.remove_button'),
                icon: 'delete',
                onClick: () => removeDistributor(person),
              },
            ]}
          >
            <span>
              {person.type === TYPES.GROUP && (
                <Users className="Icon feather inline" />
              )}
              {person.name}
            </span>
          </ListItem>
        )}
      />
    </Section>
  );
};

const mapStateToProps = ({ pathBuilder }) => ({
  pathId: pathBuilder.id,
});

export default connect(mapStateToProps)(Distributors);
